export default "__VITE_ASSET__JflPbW_6__"